import { useLocalStorage } from "@/hooks/useLocalStorage";

export const DEFAULT_GATEWAY = "nsite.lol";

/**
 * Hook for accessing and setting the nsite gateway URL.
 * Defaults to "nsite.lol" but is configurable by the user.
 */
export function useNsiteGateway(): [string, (gateway: string) => void] {
  const [gateway, setGateway] = useLocalStorage<string>(
    "nsite-gateway",
    DEFAULT_GATEWAY,
  );
  return [gateway ?? DEFAULT_GATEWAY, setGateway];
}
